var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRfsActRuralFireService = function SvgRfsActRuralFireService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rfs-act-rural-fire-service_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FD8024",
    d: "m2.492 11.675 3.433-3.433A.833.833 0 0 1 6.517 8h2.15a.833.833 0 0 1 .833.834V10.5h7.65L6.592 4.56a.833.833 0 0 1 .184-1.526.833.833 0 0 1 .632.076L20.6 10.5a1.666 1.666 0 0 1 1.4 1.667v4.167A1.667 1.667 0 0 1 20.333 18H19.5a2.5 2.5 0 0 1-5 0h-5a2.5 2.5 0 0 1-5 0h-.833A1.667 1.667 0 0 1 2 16.334v-3.475a1.667 1.667 0 0 1 .492-1.184"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rfs-act-rural-fire-service_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 3H2v17.5h20z"
  })))));
};
export default SvgRfsActRuralFireService;